import { FormField } from '@domain-group/suit-theme'

import type { BulkShareArtworksPayload } from '@hooks/useBulkShareArtworks'

import Artwork from './Artwork'

interface ArtworkListProps {
  bulkShareArtworksPayload: BulkShareArtworksPayload,
}

const ArtworkList = (props: ArtworkListProps) => {
  const {
    bulkShareArtworksPayload: {
      callbacks: {
        selectArtwork,
      },
      filteredArtworks,
      selectedArtworkIds,
    },
  } = props

  return (
    <FormField label="Select Artwork">
      {filteredArtworks.map((artwork) => {
        const selected = selectedArtworkIds.includes(artwork.id)

        return (
          <Artwork
            artwork={artwork}
            callbacks={{
              selectArtwork: () => selectArtwork(artwork),
            }}
            key={artwork.id}
            selected={selected}
          />
        )
      })}
    </FormField>
  )
}

export default ArtworkList
